// extracted by mini-css-extract-plugin
export default {"headerLeftContainer":"ProductDetails_headerLeftContainer__tzX9q","dataIcon":"ProductDetails_dataIcon__cRKYk"};